import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };
const CURR_SYM = { USD:'$',EUR:'€',JPY:'¥',CNY:'¥',KRW:'₩',RUB:'₽' };

export default function ShopFrontPage() {
  const { shopId } = useParams();
  const [shop, setShop] = useState(null);
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/api/shops/${shopId}`).then(r => setShop(r.data)).catch(() => {});
  }, [shopId]);

  const addToCart = async (productId) => {
    try {
      await axios.post('/api/market/cart/add', { productId });
      setMsg('✅ 已加入购物车');
      setTimeout(() => setMsg(''), 2000);
    } catch { setMsg('❌ 失败'); setTimeout(() => setMsg(''), 2000); }
  };

  if (!shop) return <div className="page-center"><p style={{color:'var(--text-dim)'}}>加载中...</p></div>;

  return (
    <div className="page-content">
      {/* 店铺头部 */}
      <div className="shop-front-header">
        <div className="shop-front-logo">{shop.logo || '🏪'}</div>
        <div>
          <h1 className="shop-front-name">{shop.name}</h1>
          <p className="shop-front-desc">{shop.description}</p>
          <div className="profile-tags">
            <span className="tag">{FLAGS[shop.country_code]||'🌍'} {shop.country_code}</span>
            <span className="tag">{shop.products?.length || 0} 件商品</span>
          </div>
        </div>
      </div>

      {msg && <div className="alert" style={{background:'rgba(74,222,128,0.15)',color:'#4ade80',textAlign:'center',border:'1px solid rgba(74,222,128,0.2)'}}>{msg}</div>}

      {/* 商品 */}
      <div className="users-grid" style={{marginTop:20}}>
        {(shop.products || []).map(p => (
          <div key={p.id} className="product-card">
            <div className="product-image">{p.image || '📦'}</div>
            <div className="product-info">
              <div className="product-title">{p.title}</div>
              <div className="product-desc">{p.description}</div>
              <div className="product-meta">
                <span className="meta-badge">{p.category}</span>
                <span className="meta-badge">🏭 {shop.name}</span>
              </div>
              <div className="product-price">{CURR_SYM[p.currency]||'$'}{p.price}</div>
            </div>
            <button className="btn btn-primary btn-buy" onClick={() => addToCart(p.id)}>🛒 加入购物车</button>
          </div>
        ))}
        {(shop.products || []).length === 0 && (
          <div style={{gridColumn:'1/-1',textAlign:'center',padding:60,color:'var(--text-dim)'}}>
            <div style={{fontSize:'3rem',marginBottom:12}}>📦</div>
            <p>这家店暂时没有商品</p>
          </div>
        )}
      </div>
    </div>
  );
}
